import { z } from 'zod';

/**
 * De opdrachtgever zoals de API hem stuurt (`Inspections\ClientResource`). De
 * schermen zien alleen het model uit `model.ts`.
 */
export const clientResourceSchema = z.object({
    uuid: z.string(),
    type: z.string(),
    type_label: z.string(),
    name: z.string(),
    contact_name: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    address: z.object({
        street: z.string().nullable(),
        number: z.string().nullable(),
        suffix: z.string().nullable(),
        postcode: z.string().nullable(),
        city: z.string().nullable(),
        country: z.string().nullable(),
    }),
    notes: z.string().nullable(),
    external_reference: z.string().nullable(),
    created_at: z.string().nullable(),
    updated_at: z.string().nullable(),
});

export type ClientResource = z.infer<typeof clientResourceSchema>;
